"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiManager = exports.mintManager = void 0;
var contract_1 = require("./endpoints/contract");
var mint_1 = require("./endpoints/mint");
var standard_1 = require("./endpoints/standard");
var bucket_1 = require("./endpoints/bucket");
var minter_1 = require("./endpoints/minter");
var restricted_1 = require("./endpoints/restricted");
// MARK: - Structure Exports
var mintManager = function (config) {
    return {
        mint: (0, mint_1.mint)(config)
    };
};
exports.mintManager = mintManager;
var apiManager = function (config) {
    return {
        contract: (0, contract_1.contract)(config),
        authority: (0, contract_1.authority)(config),
        standard: function (id) { return (0, standard_1.standard)(config, id); },
        standards: function (ids) { return (0, standard_1.standards)(config, ids); },
        bucket: function (id) { return (0, bucket_1.bucket)(config, id); },
        buckets: function (ids) { return (0, bucket_1.buckets)(config, ids); },
        minter: function (address) { return (0, minter_1.minter)(config, address); },
        restricted: (0, restricted_1.restricted)(config)
    };
};
exports.apiManager = apiManager;
